import { render } from "./RecentTransactionsSection.vue?vue&type=template&id=10e881ac&scoped=true"
import script from "./RecentTransactionsSection.vue?vue&type=script&lang=js"
export * from "./RecentTransactionsSection.vue?vue&type=script&lang=js"

import "./RecentTransactionsSection.vue?vue&type=style&index=0&id=10e881ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e881ac"]])

export default __exports__